const routes = {
    orderPayments: '/order',
}

export default routes
